import React, { useState, useEffect } from 'react'
import Grid from '../../components/components/Grid/Grid'
import { MortgageLabels } from '../../shared/util/label'
import { Accordion, Container } from 'react-bootstrap'
import { mortgageService } from './MortgageService'
import AllMortgageListModel from '../model/AllMortgageListModel'
import { Button as AppButton } from '../../components'
import { Icon } from '../../components/components/Icon/Icon'
import './Mortgage.scss'
import { CommonUtility } from '../../Services/CommonUtility'
import * as label from '../../shared/util/label'
import * as constant from '../../shared/util/constant'
import MortageDetails, { MortageDetailsFormModel } from './MortageDetails/MortageDetails'
import { mortageDetailsService } from './MortageDetails/MortageDetailsService'
import { toast } from 'react-toastify'
import { Button as PrimeButton } from 'primereact/button'

const Mortgage = () => {
  
  const [data, setData] = useState<AllMortgageListModel[]>([]);
  const [open, setOpen] = useState('0');
  const [newUserAt, setNewUserAt] = useState(new Date());
  const [selectedMortgage, setSelectedMortgage] = useState<MortageDetailsFormModel | null>(null);
  const [selectedMortgageId, setSelectedMortgageId] = useState<string | null>(null);

  const handleNewUserClick = () => {
    setSelectedMortgage(null);
    setSelectedMortgageId(null);
    setOpen('1');
    setNewUserAt(new Date());
  };

  const handleNewUserCancel = () => {
    setSelectedMortgage(null);
    setSelectedMortgageId(null);
    setOpen('0');
  };

  const handleEditClick = (mortgage: AllMortgageListModel) => {
    const mortgageId = mortgage.id
      ?? mortgage.mortgageCompanyId
      ?? mortgage.mortgageId;
    const fullPhone = mortgage.formattedPhone
      ?? `${mortgage.areaCode ?? mortgage.areacode ?? ''}${mortgage.phone ?? ''}`;

    setSelectedMortgage({
      companyName: mortgage?.name ?? '',
      type: mortgage?.type ?? '',
      phone: fullPhone.replace(/\D/g, '').slice(0, 10),
      city: mortgage?.city ?? '',
      state: mortgage?.state ?? '',
      isActive: typeof mortgage?.status === 'boolean'
        ? mortgage.status
        : (mortgage?.statusDescription ?? '').toLowerCase() === 'active',
    });
    setSelectedMortgageId(mortgageId ?? null);
    setOpen('1');
    setNewUserAt(new Date());
  };

  const handleNewUserSave = async (dataToSave: MortageDetailsFormModel) => {
    try {
      const isUpdate = !!selectedMortgageId;
      if (selectedMortgageId) {
        const updatePayload: MortageDetailsFormModel = {
          id: selectedMortgageId,
          ...dataToSave,
        };
        await mortageDetailsService.updateMortgageCompany(updatePayload);
      } else {
        await mortageDetailsService.saveMortgageCompany(dataToSave);
      }
      toast.success(isUpdate ? constant.UPDATE_SUCCESS_MESSAGE : constant.SUCCESS_MESSAGE, {
        position: toast.POSITION.TOP_RIGHT,
      });

      const response = await mortgageService.mortgageCompany();
      setData(response);
      setSelectedMortgageId(null);
      setOpen('0');
    } catch (ex: any) {
      const msg = ex?.data?.message || ex?.message || constant.ERROR_MESSAGE;
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    mortgageService.mortgageCompany()
      .then(response => setData(response))
    }, []);

  return (
    <Container fluid className='px-4'>
      <div className='d-flex align-items-center justify-content-between mt-3 mb-3'>
        <div className='fs-5'>{MortgageLabels.MORTGAGE_COMPANY}</div>
        <AppButton color='primary' onClick={handleNewUserClick}>
          + New Mortgage
        </AppButton>
      </div>
      <Accordion activeKey={open} key='mortgage-grid-accordion'>
        <div className='card shadow'>
          <Accordion.Collapse eventKey='0'>
            <div>
              <Grid
                id="tblMortgage"
                data={data}
                showFilters={true}
                hiddenColumns={['selection']}
                grdTableContainerClass='mortgage-grid-container'
                columns={[
                  {
                    Header: MortgageLabels.ACTION,
                    accessor: 'action',
                    disableSortBy: true,
                    width: 100,
                    Cell: ({ row }: { row: any }) => (
                      <div className='d-flex gap-2 ps-1'>
                        <PrimeButton
                          icon='bi bi-pencil'
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(row.original as AllMortgageListModel);
                          }}
                          size='small'
                          rounded
                          text
                          className='text-nowrap align-self-center customerTasks-buttons mortgage-action-btn'
                        />
                        <AppButton
                          className='btn btn-sm mortgage-action-btn'
                          onClick={(e) => { e.stopPropagation(); }}>
                          <Icon icon='merge' size='sm' outline />
                        </AppButton>
                      </div>
                    ),
                  },
                  {
                    Header: MortgageLabels.NAME,
                    accessor: 'name',
                    dataType: 'string',
                    width: 400,
                    Cell: ({ value }: { value: string }) => <div>{value}</div>,
                  },
                  {
                    Header: MortgageLabels.TYPE,
                    accessor: 'type',
                    dataType: 'string',
                    width: 250,
                    Cell: ({ value }: { value: string }) => <div>{value}</div>,
                  },
                  {
                    Header: MortgageLabels.PHONE,
                    accessor: 'formattedPhone',
                    dataType: 'string',
                    width: 150,
                    Cell: ({ value }: { value: string }) => <div>{value}</div>,
                  },
                  {
                    Header: MortgageLabels.CITY_STATE,
                    accessor: 'city',
                    dataType: 'string',
                    width: 200,
                    Cell: ({ row }: { row: any }) => <div>{[row.original.city, row.original.state].filter(Boolean).join(', ')}</div>,
                  },
                  {
                    Header: MortgageLabels.STATUS,
                    accessor: 'statusDescription',
                    dataType: 'string',
                    width: 130,
                    Cell: ({ row }: { row: any }) => <div><span className={row.original.statusDescription === 'Active' ? "activeStatus" : "inactiveStatus"}> {data !== undefined ? row.original.statusDescription : ''}</span></div>,
                  },
                  {
                    Header: MortgageLabels.LAST_MODIFIED,
                    accessor: 'changedDate',
                    dataType: 'string',
                    width: 200,
                    Cell: ({ value }: { value: string }) => (
                      <div>{CommonUtility.formateDateTime(new Date(value), CommonUtility.DateTimeFormatWithSecond)}</div>
                    ),
                  },
                ]}
                sortDefault={[]}
              />
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>

      <Accordion activeKey={open} style={{ marginTop: '12px' }} key='mortgage-details-accordion'>
        <div className='card shadow'>
          <Accordion.Collapse eventKey='1'>
            <MortageDetails
              key={newUserAt.toISOString()}
              initialData={selectedMortgage}
              onCancel={handleNewUserCancel}
              onSave={handleNewUserSave}
            />
          </Accordion.Collapse>
        </div>
      </Accordion>
    </Container>
  );
};

export default Mortgage;

